












import Vue from "vue"
import pkg from "../package.json"

export default Vue.extend({
  data() {
    return {
      showColophon: false,
      version: pkg.version,
    }
  },
})
